import React, { useState } from "react";

import { subscribeEmailToMailChimp } from "../api/amplifyService";
import * as styles from "../styles/EmailSignUp.module.css";

interface EmailSignUpProps {
  inputLabel?: string;
  setSignedUp?: React.Dispatch<React.SetStateAction<boolean>>;
  subscribeBtnText: string;
}

export default (props: EmailSignUpProps) => {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState("");

  const { inputLabel, setSignedUp, subscribeBtnText } = props;

  const newSubscribeButtonText = (text: string) => {
    const confirmButton = document.getElementById("confirmEmail");
    if (confirmButton) {
      confirmButton.textContent = text;
    }
  };

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onSubmit = async () => {
    const trimmedEmail = email.trim();
    if (trimmedEmail === "") {
      setSubscribeStatus("Please enter an email address.");
      return;
    }
    if (!validateEmail(trimmedEmail)) {
      setSubscribeStatus("Please enter a valid email address.");
      return;
    }
    newSubscribeButtonText("Subscribing...");
    const response = await subscribeEmailToMailChimp(email);
    if (response.status === "subscribed") {
      setEmail("");
      newSubscribeButtonText("Subscribed!");
      setSubscribeStatus("");
      setTimeout(() => {
        if (setSignedUp) {
          setSignedUp(true);
        }
        localStorage.setItem("showEmailSignUpModal", "false");
      }, 3000);
      return;
    }
    setEmail("");
    newSubscribeButtonText("Subscribe");
    setSubscribeStatus("Something went wrong. Please try again.");
  };

  return (
    <div className={styles.emailInputContainer}>
      <label className={styles.label}>{inputLabel}</label>
      <input
        type="input"
        placeholder="Enter your email"
        onChange={(e) => {
          setEmail(e.target.value);
        }}
        value={email}
        className={styles.input}
      />
      {subscribeStatus !== "" && (
        <p className={styles.response}>{subscribeStatus}</p>
      )}
      <button
        id={"confirmEmail"}
        onClick={async () => {
          await onSubmit();
        }}
        className={styles.confirmEmailButton}
      >
        {subscribeBtnText}
      </button>
    </div>
  );
};
